import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComPhoto, BuyerPopup, BookMarkStore, Alert, NoResult, Confirm } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:도매매장 찜하기
 * 세부설명:
*/

export class BoorkMarkStore extends Component {
    static displayName = BoorkMarkStore.name;

    constructor(props) {
        super(props);
        this.state = {
            BookMarkList: [],
            OrderList: [],
            Bookmark_Yn: "N",
            Whole_Code: "",
            Bill_Yn: "N",
            Refund_Yn: "N",
            Title: "",
            Content: "",
            SearchText: ""

        };
        this.CsName = Big3Common.ContentState;
        this.CallMyBokmkStoreList = this.CallMyBokmkStoreList.bind(this);
        this.handleBuyer_Click = this.handleBuyer_Click.bind(this);
        this.ref_BuyerPopup = React.createRef();
        this.handleStore_Click = this.handleStore_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleInit = this.handleInit.bind(this);
        this.handleCancel_Click = this.handleCancel_Click.bind(this);
        this.GetAlreadyOrder = this.GetAlreadyOrder.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallMyBokmkStoreList();
        this.GetAlreadyOrder();
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
        }
    }
    async CallMyBokmkStoreList(Search_Text) {
        try {
            Big3Common.Util.LoadingOn();
/*            if (/^\d+$/.test(Search_Text) && Search_Text !== undefined) {
                await this.setState(prevState => ({
                    OrderList: [...prevState.OrderList, Search_Text.toString()]
                }));
                Search_Text = "";
            }*/
            let Data = await Big3Common.Post('api/MyPage/BookMark/GetMyBokmkStoreList', {
                Search_Text: Search_Text !== "" ? Search_Text : this.state.SearchText,
            }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                let Bookmark_Yn = "N";
                if (DataList.length > 0) {
                    Bookmark_Yn = DataList[0].bookmark_yn;
                }
                this.setState({ BookMarkList: DataList, Bookmark_Yn: Bookmark_Yn });
                return DataList;
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallMyBokmkStoreList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    async GetAlreadyOrder() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/MyPage/OrderMgr/GetAlreadyOrder", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const OrderList = JSON.parse(Data.dataTable);
                this.setState({
                    OrderList: OrderList
                });
            }
        }
        catch (e) {
            console.log("GetAlreadyOrder :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    handleBuyer_Click(event, whole_code) {
        if (this.Uid_Type === 'SS') {
            this.ref_BuyerPopup.current.initWholeCode(whole_code)
            Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
            event.preventDefault();
        }
        else {
            if (this.state.Bill_Yn === 'N') {
                this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
/*            else if (this.state.Refund_Yn === 'Y') {
                this.setState({ Title: "환불 진행중에는 주문이 불가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }*/
            else if (this.state.Bill_Yn === 'Y' && this.state.Refund_Yn === 'N') {
                this.ref_BuyerPopup.current.initWholeCode(whole_code)
                Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
                event.preventDefault();
            }
        }         
    }
    handleAlert(event) {
        this.setState({
            Title: "택배주문안내",
            Content: "택배주문은 장바구니에서 가능합니다."
        });
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        event.preventDefault();
    }
    //도매상세 이동
    handleStore_Click(event, list) {
        
        if (list.uid !== undefined && list.uid !== null && list.uid !== "") {
            
            this.props.RenderComponent("StoreDtl", {
                [this.CsName.Uid]: list.uid,
                [this.CsName.Goods_No]: list.goods_no,
                [this.CsName.BackUrl]: "BoorkMarkStore"
            });
        }
        else {
            this.setState({
                Title: "매장안내",
                Content: `${list.whole_name}는 플랫폼에 가입된 도매가 아닙니다.`
            });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
        }

        event.preventDefault();
    }
    //검색조건 초기화
    handleClear_Click(event) {
        if (this.state.BookMarkList.length > 0) {
            this.setState({
                SearchText: ""
            });
        }
        event.preventDefault();
    }
    async handleSearch_Change(event) {
        let Value = event.target.value;
        this.setState({ SearchText: Value });
        event.preventDefault();
    }
    //도매상가 검색 엔터
    async handleSearch_Click(event) {
        if (event.keyCode === 13) {

            //if (this.state.SearchText.trim() === "") {
            //    this.setState({ Title: "도매명을 입력하여 주세요." });
            //    Big3Common.ModalAlert(bootstrap, "MessageAlert");
            //    return false;
            //}
            const WholeList = await this.CallMyBokmkStoreList(this.state.SearchText);
            if (WholeList.length === 0) {
                this.setState({ Title: "검색 결과가 없습니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            this.setState({
                BookMarkList: WholeList,
            });
            console.log(WholeList)
        }
        event.preventDefault();
    }
    //필터 초기화
    handleInit() {
        this.setState({
            SearchText: "",
        });
        this.CallMyBokmkStoreList();
    }
    //주문취소
    DeleteModel = {
        uid: "",
        ordgrp_no: "",
        order_code: "",
        whole_code: "",
        type: "",
        ord_dt: ""
    };
    handleCancel_Click(DelData, Type) {

        if (Type === "SP") {
            //상품리스트 삭제 클릭
            this.DeleteModel.uid = DelData.uid;
            this.DeleteModel.ordgrp_no = DelData.ordgrp_no;
            this.DeleteModel.ord_dt = DelData.order_dt;
            this.DeleteModel.type = Type;
        }
        else {
            //사입내역 삭제 클릭
            this.DeleteModel.order_code = DelData[0].order_code;
            this.DeleteModel.ord_dt = DelData[0].order_dt;
            this.DeleteModel.whole_code = DelData[0].whole_code;
            this.DeleteModel.type = Type;
        }
        Big3Common.ModalAlert(bootstrap, "CancelConfirm");
        return false;
    }
    //취소처리 Rest전송--> Confirm창 취소 실행
    async handleCancel_Post() {
        try {
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/CancelOrdMgt', this.DeleteModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "CompleteCancel");
                await this.GetAlreadyOrder();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleCancel_Post", e);
        }
        finally {
            this.DeleteModel.uid = "";
            this.DeleteModel.ordgrp_no = "";
            this.DeleteModel.order_code = "";
            this.DeleteModel.type = "";
        }
        return false;

    }
    render() {
        let BookMarkList = this.state.BookMarkList;
        const OrderList = this.state.OrderList;
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap"><div className="alert_tap" onClick={() => { this.props.RenderComponent('BoorkMarkGoods') }}>찜한 상품</div></div>
                    <div className="n_tap"><div className="alert_tap  tap_on" >찜한 매장</div></div>
                </div>
                <div className="m_f_margin d_padding bookmark_wrap container_box">
                    <div className="search_box_v3">
                        <input type="search"
                            inputMode="search"
                            enterKeyHint="search"
                            placeholder="도매 상가명을 검색해주세요"
                            className="form-control"
                            onKeyUp={(e) => { this.handleSearch_Click(e) }}
                            onChange={this.handleSearch_Change}
                            value={this.state.SearchText}
                        />
                        <div className="search_icon"></div>
                        <div className="search_delete" onClick={(e) => { this.handleClear_Click(e) }}></div>
                    </div>
                    <div className="select_box">
                        <div className="category_box reset" onClick={this.handleInit}>
                            <div className="category">초기화</div>
                            <div className="reset_btn"></div>
                        </div>
                    </div>
                    {
                        BookMarkList.map(list => 
                            <div className="alert_content_v2 alert_content" key={list.whole_code}>
                                <div className="alert_img" onClick={(e) => { this.handleStore_Click(e, list) } }>
                                    <ComPhoto className="alert_img_in" Photo={list.photo} />
                                </div>
                                <div className="alert_txt">
                                    <div className="shop_name">{list.whole_name}
                                        <span className="go_s" onClick={(e) => { this.handleStore_Click(e, list) }}></span>
                                    </div>
                                    <div className="shop_address">{list.bld_name} {list.flr_name}층 {list.whole_no_name }호</div>
                                    <BookMarkStore
                                        Whole_Code={list.whole_code}
                                        HeartOn={list.bookmark_yn === "Y" ? true : false}
                                        CallBack={this.CallMyBokmkStoreList}
                                    />
                                    {
                                        OrderList.some(order => String(order.whole_code) === String(list.whole_code)) ? (
                                            <div className="order_btn or_btn4 btn_v2" onClick={() => { this.handleCancel_Click(OrderList, 'SI') }}>주문취소</div>
                                        ) : (
                                            this.Uid_Type === 'SS' ? (
                                                <div className="order_btn or_btn4"
                                                    onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                                >사입요청</div>
                                            ) : (
                                                <div className="order_btn or_btn4"
                                                    onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                                >픽업요청</div>
                                            )
                                        )
                                    }
                                    <Link to={`/Chat/LiveChat/Index?uid=${list.uid}`}>
                                        <div className="chat_icon3"></div>
                                    </Link>
                                </div>
                            </div>
                    )}
                </div>
                <BuyerPopup
                    id="BuyerPopup"
                    ref={this.ref_BuyerPopup}
                    CallBack={this.GetAlreadyOrder}
                />
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <Alert
                    id="CompleteCancel"
                    content={this.state.Content}
                    title="취소완료"
                />
                <NoResult
                    Visible={this.state.BookMarkList.length === 0 ? true : false}
                    Top={"50%"}
                />
                <Confirm
                    id="CancelConfirm"
                    title="취소 하시겠습니까?"
                    content="완료되지 않은 사입내역이 존재하면<br/> 사입내역까지 취소 합니다."
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'CancelConfirm');
                        }, 500);
                        this.handleCancel_Post()
                    }}
                />
            </div>
        );
    }
}
